import { useState } from "react";

export function useGalleryModal() {
    const [selectedMedia, setSelectedMedia] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);

    const openModal = ({ media, location }) => {
        setSelectedMedia(media);
        setSelectedLocation(location);
    };

    const closeModal = () => {
        setSelectedMedia(null);
        setSelectedLocation(null);
    };

    return {
        selectedMedia,
        selectedLocation,
        openModal,
        closeModal
    };
} 